/* Elyvon — scripts du thème (vanilla, sans dépendance) */
(function () {
  'use strict';

  /* Formatage monnaie à partir de shop.money_format (ex. "{{amount_with_comma_separator}}€") */
  var money = function (cents, fmt) {
    fmt = fmt || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var noDec = Math.round(cents / 100).toString();
    return fmt
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDec)
      .replace('{{amount_no_decimals}}', noDec)
      .replace('{{amount}}', amount);
  };

  /* Menu mobile */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;
      var open = menu.hasAttribute('open');
      if (open) menu.removeAttribute('open'); else menu.setAttribute('open', '');
      btn.setAttribute('aria-expanded', String(!open));
    });
  });

  /* Sélecteurs de quantité (hero + panier) */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qminus]');
    var plus = wrap.querySelector('[data-qplus]');
    if (!input) return;
    var change = function (delta) {
      var v = parseInt(input.value, 10) || 1;
      v = Math.max(parseInt(input.min, 10) || 0, v + delta);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    if (minus) minus.addEventListener('click', function () { change(-1); });
    if (plus) plus.addEventListener('click', function () { change(1); });
  });

  /* Panier : mise à jour AJAX de la quantité (prix de ligne, sous-total, total, badge) sans rechargement.
     Fonctionne aussi dans l'aperçu de l'éditeur de thème, où la soumission du formulaire est bloquée. */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    var fmt = cartForm.dataset.moneyFormat;
    var changeUrl = cartForm.dataset.changeUrl || '/cart/change.js';
    var busy = false;
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var item = input.closest('[data-line]');
        var line = item ? parseInt(item.dataset.line, 10) : 0;
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        if (!line || !window.fetch) { cartForm.submit(); return; }
        if (busy) return;
        busy = true;
        cartForm.classList.add('is-updating');
        fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
          .then(function (cart) {
            var lines = cartForm.querySelectorAll('[data-line]').length;
            /* Article retiré, panier vide ou remise : on recharge pour un rendu exact */
            if (cart.item_count === 0 || cart.items.length !== lines || cart.total_discount > 0) { window.location.reload(); return; }
            var li = cart.items[line - 1];
            input.value = li.quantity;
            var lp = item.querySelector('[data-line-price]');
            if (lp) lp.textContent = money(li.final_line_price, fmt);
            var st = cartForm.querySelector('[data-cart-subtotal]');
            if (st) st.textContent = money(cart.items_subtotal_price, fmt);
            var tt = cartForm.querySelector('[data-cart-total]');
            if (tt) tt.textContent = money(cart.total_price, fmt);
            document.querySelectorAll('.nav-cart .count').forEach(function (c) { c.textContent = cart.item_count; });
            busy = false;
            cartForm.classList.remove('is-updating');
          })
          .catch(function () { busy = false; cartForm.submit(); });
      });
    });
  }

  /* Sections produit (hero) */
  document.querySelectorAll('[data-product-section]').forEach(function (root) {
    /* Galerie */
    var main = root.querySelector('.main-image img');
    /* L'image principale est rendue avec srcset/sizes : il faut les retirer, sinon le navigateur ignore src */
    var swapMain = function (src, alt) {
      if (!main || !src) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
      if (alt) main.alt = alt;
    };
    root.querySelectorAll('.thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.thumb').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        swapMain(btn.dataset.src, btn.dataset.alt);
      });
    });

    /* Variantes : mise à jour prix / disponibilité */
    var select = root.querySelector('[data-variant-select]');
    var dataEl = root.querySelector('[data-variants-json]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var submit = root.querySelector('[data-submit]');
    var pfmt = root.dataset.moneyFormat;
    if (select && dataEl) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      select.addEventListener('change', function () {
        var id = parseInt(select.value, 10);
        var v = variants.filter(function (x) { return x.id === id; })[0];
        if (!v) return;
        if (priceEl) priceEl.textContent = money(v.price, pfmt);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price, pfmt); compareEl.hidden = false; }
          else compareEl.hidden = true;
        }
        if (submit) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? submit.dataset.labelAdd : submit.dataset.labelSoldOut;
        }
        if (v.featured_image) swapMain(v.featured_image.src);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    /* Barre sticky */
    var sticky = root.querySelector('[data-sticky]');
    var hero = root.querySelector('.hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0.05 }).observe(hero);
      var stickyBtn = sticky.querySelector('[data-sticky-submit]');
      var form = root.querySelector('form[action*="/cart/add"]');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
        });
      }
    }
  });
})();
